<template>
	<div>
		<div :id="idMap" class="divMap" :style="{ height: heightMap }"></div>
	</div>
</template>

<script>
export default {
	name: 'Geolocation',
	props: {
		idMap: {
			type: String,
			required: true,
		},
		person: {
			type: Object,
			required: true,
		},
		heightMap: {
			type: String,
			default: '400px',
		},
	},
	data() {
		return {
			map: null,
		};
	},
	mounted() {
		this.initMap();
	},
	methods: {
		async initMap() {
			var myLatLng = {
				lat: this.person.geolocation.coordinates[0],
				lng: this.person.geolocation.coordinates[1],
			};
			// eslint-disable-next-line no-undef
			this.map = new google.maps.Map(document.getElementById(this.idMap), {
				zoom: 17,
				center: myLatLng,
				streetViewControl: false,
				scaleControl: true,
				fullscreenControl: false,
				scrollwheel: true,
			});
			// eslint-disable-next-line no-undef
			var marker = new google.maps.Marker({
				position: myLatLng,
				map: this.map,
				label: this.person.firstName.substring(0, 1),
			});

			marker.setMap(this.map);
		},
	},
};
</script>

<style lang="scss" scoped>
.divMap {
	background-color: white;
	width: 100%;
}
</style>
